if (!customElements.get('jsp-print-options')) {
  customElements.define('jsp-print-options', class extends HTMLElement {
    connectedCallback() {
      if (this.onSubmit) return;
      this.select = this.querySelector('select');
      this.fields = this.querySelector('.jsp-print-fields');
      this.error = this.querySelector('.jsp-print-error');
      this.onChange = () => this.sync();
      this.onSubmit = (event) => {
        if (event.target.getAttribute('id') !== this.dataset.formId) return;
        this.sync();
        if (this.select.value !== 'Custom print requested') return;
        const inputs = [...this.fields.querySelectorAll('input[type="text"]')];
        inputs.forEach(input => input.value = input.value.trim());
        let message = '';
        if (!inputs.some(input => input.value)) message = 'Enter a name or number for your custom print request.';
        else if (!inputs.every(input => input.checkValidity())) message = 'Check your name and use digits only for a printed number.';
        else if (!this.querySelector('.jsp-print-confirm-input').checked) message = 'Please confirm your print request and selected size.';
        if (message) {
          event.preventDefault(); event.stopImmediatePropagation();
          this.error.textContent = message; this.error.hidden = false; this.error.focus();
        }
      };
      this.select.addEventListener('change', this.onChange);
      document.addEventListener('submit', this.onSubmit, true);
      this.sync();
    }
    sync() {
      const custom = this.select.value === 'Custom print requested';
      this.fields.hidden = !custom;
      this.fields.querySelectorAll('input').forEach(input => { input.disabled = !custom; });
      this.error.hidden = true;
    }
    disconnectedCallback() {
      this.select?.removeEventListener('change', this.onChange);
      document.removeEventListener('submit', this.onSubmit, true);
      this.onSubmit = null;
    }
  });
}
